<template>
  <nav class="pagination-wrap text-left">
    <ul v-if="(totalPages > 1)" class="pagination">
      <li v-if="hasPrev()" class="pagination__left" :class="{ disabled: !hasPrev() }">
        <a href="#" @click.prevent="changePage(prevPage)">Prev</a>
      </li>

      <li v-if="hasFirst()">
        <a href="#" @click.prevent="changePage(1)">1</a>
      </li>

      <li v-if="hasFirst()">
        <a href="#" @click.prevent="">...</a>
      </li>

      <li v-for="page in pages" :key="page" :class="{ active: currentPage == page }">
        <a href="#" @click.prevent="changePage(page)">
          {{ page }}
        </a>
      </li>

      <li v-if="hasLast()">
        <a href="#" @click.prevent="">...</a>
      </li>

      <li v-if="hasLast()">
        <a href="#" @click.prevent="changePage(totalPages)">
          {{ totalPages }}
        </a>
      </li>

      <li class="pagination__right">
        <a v-if="hasNext()" href="#" @click.prevent="changePage(nextPage)">Next</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 25,
    },
    offset: {
      type: Number,
      default: 0,
    },
    pageRange: {
      type: Number,
      default: 3,
    },
    maxPages: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      pageInput: 1,
    };
  },

  computed: {
    currentPage() {
      return this.offset / this.size + 1;
    },
    pages() {
      const pages = [];

      for (let i = this.rangeStart; i <= this.rangeEnd; i += 1) {
        pages.push(i);
      }

      return pages;
    },
    rangeStart() {
      const start = this.currentPage - this.pageRange;

      return (start > 0) ? start : 1;
    },
    rangeEnd() {
      const end = this.currentPage + this.pageRange;

      return (end < this.totalPages) ? end : this.totalPages;
    },
    totalPages() {
      const pageAmount = Math.ceil(this.total / this.size);

      if (this.maxPages !== 0 && pageAmount > this.maxPages) {
        return this.maxPages;
      }
      return pageAmount;
    },
    nextPage() {
      return this.currentPage + 1;
    },
    prevPage() {
      return this.currentPage - 1;
    },
  },

  methods: {
    hasFirst() {
      return this.rangeStart !== 1;
    },
    hasLast() {
      return this.rangeEnd < this.totalPages;
    },
    hasPrev() {
      return this.currentPage > 1;
    },
    hasNext() {
      return this.currentPage < this.totalPages;
    },
    changePage(page) {
      const newOffset = (page - 1) * this.size;
      this.pageInput = page;
      this.$emit('page-changed', newOffset);
    },
  },
};
</script>



// WEBPACK FOOTER //
// Pager.vue?4c782872